module.exports = __webpack_public_path__ + "img/banner.916c469a.png";